module.exports = __webpack_public_path__ + "img/lamiapratica_nero.3e9a4658.png";